import type { ReactElement } from 'react';

import type { ISingleHistoryBet, ISingleHistory } from '../../../../../../api/fetchers/history/types';
import { CurrencyConnected } from '../../../../../currency/CurrencyConnected';
import { L12nText } from '../../../../../text/L12nText';
import { NetCash } from '../../components/NetCash';

import styles from './MegaSicBacTableResult.module.css';

export default function MegaSicBacTableResult({ game, bets }: ISingleHistory): ReactElement {
  return (
    <>
      <thead>
        <tr>
          <td className={styles.megaSicBacTableHead}>
            <L12nText tk="BETTYPE" />
          </td>
          <td className={styles.megaSicBacTableHead}>
            <L12nText tk="BET_LABEL" />
          </td>
          <td className={styles.megaSicBacTableHead}>
            <L12nText tk="NETCASH" />
          </td>
        </tr>
      </thead>
      <tbody>
        {bets.map((bet: ISingleHistoryBet, index: number) => {
          return (
            <tr key={index}>
              <td className={styles.megaSicBacTableBody}>
                {bet.description}{' '}
                <span className={styles.boosted}>
                  {bet.playerMul ? `${Math.floor(parseFloat(bet.playerMul))}:1` : null}
                </span>
              </td>
              <td className={styles.megaSicBacTableBody}>
                <CurrencyConnected value={Number(bet.amount)} />
              </td>
              <td className={`${styles.megaSicBacTableBody} ${Number(bet.netCash) > 0 ? styles.win : styles.lose}`}>
                {game.cancelled && Number(bet.netCash) == 0 ? (
                  <span className={styles.refunded}>
                    <L12nText tk="REFUNDED" />
                  </span>
                ) : (
                  <NetCash bet={bet} />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
}
